module.exports = __webpack_public_path__ + "img/homedog-left1.ef4a1476.png";